var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: 70,
            "footer-hide": true,
            title: "入库记录",
            "class-name": "vertical-center-modal",
          },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c("Col", { attrs: { span: "24" } }, [
                    _c("div", { staticClass: "global-tool-bar" }, [
                      _c("div", { staticClass: "left-bar" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("备用库入库单列表"),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "right-bar" },
                        [
                          _vm.$checkAccessArray(["B", "C"])
                            ? _c(
                                "Button",
                                {
                                  staticClass: "btns",
                                  attrs: {
                                    size: "small",
                                    shape: "circle",
                                    type: "success",
                                    icon: "ios-add-circle-outline",
                                  },
                                  on: {
                                    click: _vm.onCreateWarehouseForwardEntry,
                                  },
                                },
                                [_vm._v("新增")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("stand-pagination-table", {
                        attrs: {
                          columns: _vm.mainTable.columns,
                          data: _vm.mainTable.data,
                          loading: _vm.mainTable.loading,
                          "table-search": _vm.mainTable.tableSearch,
                          "table-load-event":
                            _vm.getWarehouseForwardEntryTableRecord,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("WarehouseForwardEntryEdit", {
        ref: "warehouseForwardEntryEditModal",
      }),
      _c("WarehouseForwardEntryDetail", {
        ref: "warehouseForwardEntryDetailModal",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }